import {
  finishLoading,
  startLoading,
} from '../../../connected-components/loading/actions';
import {ChangePasswordBody} from '../../../interfaces/api/tabs';
import {services} from '../../../api';
import {showGlobalToast} from '../../../connected-components/toast/actions';
import {store} from '../../../redux/store';
import {startSession} from '../../auth/login/actions';
import {ToastType} from '../../../utils/enums';

/**
 * this function to change password
 *
 * @param body {ChangePasswordBody}
 */
export const changePassword = async (
  body: ChangePasswordBody,
): Promise<boolean> => {
  try {
    startLoading();
    const res = await services.home.changePassword(body);
    if (res?.content?.message) {
      const {currentUser} = store.getState().auth || {};
      startSession({...(currentUser || {}), password: body?.new_password});
      showGlobalToast({
        message: res?.content?.message,
        type: ToastType.HELP,
      });
    }
    return true;
  } catch (error: any) {
    return false;
  } finally {
    finishLoading();
  }
};
